import './App.css';
import './WinOdometer.css';
import Odometer from 'react-odometerjs';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const isNonEgm = (ess) => (ess || '').includes('::');

const displayNameForPlayer = (player, playerESS) => {
    const baseName = (player?.Alias || '').trim() || player?.ESS || 'Unknown Player';
    return player?.ESS === playerESS ? `${baseName} (You)` : baseName;
};

const leaderboardRows = (players, playerESS) => {
    return (players || [])
        .filter((player) => player && player.ESS)
        .slice()
        .sort((left, right) => {
            const winDelta = (right.EndPrizeWins || 0) - (left.EndPrizeWins || 0);
            if (winDelta !== 0) {
                return winDelta;
            }
            const leftName = displayNameForPlayer(left, playerESS).toLowerCase();
            const rightName = displayNameForPlayer(right, playerESS).toLowerCase();
            if (leftName !== rightName) {
                return leftName.localeCompare(rightName);
            }
            return (left.ESS || '').localeCompare(right.ESS || '');
        })
        .map((player, index) => ({
            ...player,
            Rank: index + 1,
            DisplayName: displayNameForPlayer(player, playerESS),
            PlayerType: isNonEgm(player.ESS) ? 'NON-EGM' : 'EGM'
        }));
};

const Leaderboard = (props) => {
    const rows = leaderboardRows(props.players, props.playerESS);

    const WinOdometer = (row) => {
        return <Odometer value={row.EndPrizeWins || 0} duration={500}/>;
    };

    if (props.visible) {
        return (
            <div className="table-wrapper">
                <h4 className="table-name">Leaderboard</h4>
                <DataTable value={rows} stripedRows showGridlines columnResizeMode="expand" dataKey="ESS" scrollable
                           scrollHeight="400px" tableStyle={{minWidth: '40rem'}}>
                    <Column field="Rank" header="Rank"></Column>
                    <Column field="DisplayName" header="Player"></Column>
                    <Column field="PlayerType" header="Type"></Column>
                    <Column field="ESS" header="ID"></Column>
                    <Column header="Game Ending Prize Wins" body={WinOdometer}></Column>
                </DataTable>
            </div>
        );
    }
    return null;
}

export default Leaderboard;
